import { forwardRef } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/generated/IconFileDelete.tsx
const IconFileDelete = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 24 24",
	"aria-hidden": "true",
	"data-slot": "icon",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ jsx("path", {
		fill: "currentColor",
		d: "M6 12h12V8h-4V4H6zm-2 0V2.995c0-.55.445-.995.996-.995H15l5 5v5h2v2H2v-2zm-1 4h2v6H3zm16 0h2v6h-2zm-4 0h2v6h-2zm-4 0h2v6h-2zm-4 0h2v6H7z"
	})]
});
var IconFileDelete_default = forwardRef(IconFileDelete);
//#endregion
export { IconFileDelete_default as default };
